import { render, staticRenderFns } from "./TooltipEstado.vue?vue&type=template&id=4a128216&scoped=true&"
import script from "./TooltipEstado.vue?vue&type=script&lang=ts&"
export * from "./TooltipEstado.vue?vue&type=script&lang=ts&"
import style0 from "./TooltipEstado.vue?vue&type=style&index=0&id=4a128216&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a128216",
  null
  
)

export default component.exports